import { Text, chakra } from "@chakra-ui/react"
import { colours } from "@shared/ui.design-system"
export const MembersPrice = chakra(Text, {
  baseStyle: {
    mt: 0,
    textAlign: "center",
    borderRight: `1px solid ${colours.secondary.strong}`,
    fontSize: 1,
  },
})
export const NonMembersPrice = chakra(Text, {
  baseStyle: {
    mt: 0,
    textAlign: "center",
    fontSize: 1,
  },
})

export const PriceCopy = chakra(Text, {
  baseStyle: {
    mt: 0,
    fontWeight: 500,
  },
})

export const primaryPriceStyle = {
  fontWeight: 700,
  color: colours.primary.dark,
}
export const secondaryPriceStyle = {
  fontWeight: 500,
  color: colours.primary.medium,
}
